// pages/pays/EditPaysModal.jsx
import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { X, AlertCircle } from 'lucide-react';

export default function EditPaysModal({ isOpen, onClose, onSuccess, pays }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({ Code: '', Nom: '', CodeTravail: '', FuseauHoraire: '', EstActif: true });

  useEffect(() => {
    if (isOpen && pays) setFormData({
      Code: pays.Code || '', Nom: pays.Nom || '', CodeTravail: pays.CodeTravail || '',
      FuseauHoraire: pays.FuseauHoraire || 'Africa/Casablanca', EstActif: pays.EstActif === true || pays.EstActif === 1
    });
  }, [isOpen, pays]);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    if (!formData.Code.trim() || !formData.Nom.trim()) { setError('Code et Nom sont obligatoires'); setLoading(false); return; }
    try {
      const response = await api.put(`/pays/${pays.ID_Pays}`, formData);
      if (response.data.success) { onSuccess(); onClose(); } else { setError(response.data.message); }
    } catch (err) { setError(err.response?.data?.message || 'Erreur lors de la modification'); }
    finally { setLoading(false); }
  };

  if (!isOpen || !pays) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-blue-600">✏️ Modifier le pays</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
        </div>
        {error && <div className="mb-4 p-3 bg-red-50 text-red-600 text-sm rounded-lg flex items-center gap-2"><AlertCircle size={16} /> {error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Code *</label>
              <input type="text" className="w-full p-2 border rounded-lg text-sm" value={formData.Code} onChange={(e) => setFormData({...formData, Code: e.target.value.toUpperCase()})} maxLength={3} required /></div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Nom *</label>
              <input type="text" className="w-full p-2 border rounded-lg text-sm" value={formData.Nom} onChange={(e) => setFormData({...formData, Nom: e.target.value})} required /></div>
          </div>
          <div><label className="block text-sm font-medium text-gray-700 mb-1">Code du travail</label>
            <input type="text" className="w-full p-2 border rounded-lg text-sm" value={formData.CodeTravail} onChange={(e) => setFormData({...formData, CodeTravail: e.target.value})} /></div>
          <div><label className="block text-sm font-medium text-gray-700 mb-1">Fuseau horaire</label>
            <input type="text" className="w-full p-2 border rounded-lg text-sm" value={formData.FuseauHoraire} onChange={(e) => setFormData({...formData, FuseauHoraire: e.target.value})} /></div>
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" checked={formData.EstActif} onChange={(e) => setFormData({...formData, EstActif: e.target.checked})} className="w-4 h-4 text-blue-500 rounded" />
            <span className="text-sm text-gray-700">Pays actif</span></label>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition text-sm">Annuler</button>
            <button type="submit" disabled={loading} className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 text-sm">{loading ? 'Enregistrement...' : 'Modifier'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}